// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Page Styles */
.page-container {
  min-height: 60vh;
  background-color: var(--color-secondary);
  padding: 4rem 2rem;
}

.page-content {
  max-width: 1500px;
  margin: 0 auto;
  color: var(--color-text-primary);
}

.page-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--color-primary);
  text-align: center;
}

.page-content h2 {
  font-size: 2rem;
  font-weight: 600;
  margin: 2rem 0 1rem 0;
  color: var(--color-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.content-section {
  padding: 2rem;
  border-radius: 15px;
  margin-bottom: 2rem;
}

.content-section p {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: var(--color-text-primary);
}

.content-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.content-section li {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  color: var(--color-text-primary);
}

/* About Page Specific Styles */
.about-page {
  background-color: var(--color-secondary);
}

.about-content {
  padding: 0rem 2rem;
  min-height: auto;
}

.about-main {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.about-description {
  font-size: 1rem !important;
  line-height: 1.6 !important;
  color: var(--color-text-primary);
  margin-bottom: 2rem;
  text-align: justify;
}

.about-cta {
  line-height: 1.8;
  color: var(--color-text-secondary)!important;
  margin-top: 2rem;
  text-align: center;
}

.about-festivals-section {
  background-color: var(--color-secondary);
  padding-top: 0;
  padding-bottom: 2rem;
  padding-left: 0;
  padding-right: 0;
}

/* Alexander V. Kammel Biography Page Specific Styles */
.alexander-kammel-page {
  background-color: var(--color-secondary);
}

.alexander-kammel-content {
  padding: 0rem 2rem;
  min-height: auto;
}

.alexander-kammel-main {
  max-width: 1500px;
  margin: 0 auto;
}

.alexander-kammel-text-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-bottom: 4rem;
}

.alexander-kammel-left-column,
.alexander-kammel-right-column {
  color: var(--color-text-primary);
}

.alexander-kammel-left-column p,
.alexander-kammel-right-column p {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  text-align: justify;
}

.alexander-kammel-images-section {
  background-color: var(--color-white);
  width: 100%;
  padding: 4rem 0;
}

.alexander-kammel-images-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
}

.alexander-kammel-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.alexander-kammel-image {
  width: 100%;
}

.alexander-kammel-image img {
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: top;
}

/* Tablet Responsive Design */
@media (max-width: 768px) and (min-width: 500px) {
  .alexander-kammel-images-section {
    padding: 3rem 0;
  }
  
  .alexander-kammel-images-container {
    padding: 0 1rem;
  }
  
  .alexander-kammel-image img {
    height: 500px;
    object-fit: cover;
    object-position: top;
  }
}

/* Mobile Responsive Design */
@media (max-width: 500px) {
  .page-container {
    padding: 2rem 1rem;
  }
  
  .page-content h1 {
    font-size: 2rem;
  }
  
  .page-content h2 {
    font-size: 1.5rem;
  }
  
  .content-section {
    padding: 1.5rem;
  }

  .about-content {
    padding: 2rem 1rem;
  }
  
  .about-description {
    font-size: 1rem;
    text-align: left;
  }
  
  .about-cta {
    font-size: 1rem;
    text-align: left;
  }

  .alexander-kammel-content {
    padding: 2rem 1rem;
  }
  
  .alexander-kammel-text-columns {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
  }
  
  .alexander-kammel-left-column p,
  .alexander-kammel-right-column p {
    font-size: 0.9rem;
    text-align: left;
  }
  
     .alexander-kammel-images-section {
     padding: 2rem 0;
   }
   
   .alexander-kammel-images-container {
     padding: 0 1rem;
   }
   
   .alexander-kammel-images {
     grid-template-columns: 1fr;
     gap: 1.5rem;
   }
   
   .alexander-kammel-image img {
     height: 400px;
     object-fit: cover;
     object-position: top;
   }
}

/* Film + Video Magazine Page Styles */
.film-video-magazine-page {
  width: 100%;
  min-height: 100vh;
}

.film-video-magazine-content {
  background-color: white;
  padding: 4rem 0;
  min-height: 100vh;
}

.film-video-magazine-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
}

.magazine-section-title {
  font-family: var(--font-family-primary);
  font-size: 3rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 3rem 0;
  text-transform: uppercase;
  letter-spacing: -0.02em;
}

/* Team Section */
.magazine-team-section {
  margin-bottom: 6rem;
}

.magazine-team-item {
  margin-bottom: 3rem;
}

.magazine-team-role {
  font-family: var(--font-family-primary);
  font-size: 1.5rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

.magazine-team-name {
  font-family: var(--font-family-primary);
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-text-dark);
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

/* Magazine Section */
.magazine-covers-section {
  margin-bottom: 4rem;
}

.magazine-subtitle {
  font-family: var(--font-family-primary);
  font-size: 2rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 3rem 0;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

.magazine-covers-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0rem;
  margin-top: 2rem;
  justify-items: center;
}

.magazine-cover-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.magazine-cover-image {
  width: 100%;
  max-width: 300px;
  margin-bottom: 0.5rem;
  display: block;
  text-decoration: none;
}

.magazine-cover-image img {
  width: 100%;
  height: 300px;
  object-fit: contain;
  object-position: center;
  transition: transform 0.3s ease;
  background-color: var(--color-primary);
  padding: 4rem;
}

.magazine-cover-image img:hover {
  transform: scale(1.05);
}

.magazine-cover-hashtags {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0rem;
}

.magazine-hashtag {
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-dark);
  text-transform: lowercase;
}

/* Responsive Design */
@media (max-width: 768px) {
  .film-video-magazine-content {
    padding: 2rem 0;
  }
  
  .magazine-section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  
  .magazine-team-section {
    margin-bottom: 4rem;
  }
  
  .magazine-team-item {
    margin-bottom: 2rem;
  }
  
  .magazine-team-role {
    font-size: 1.2rem;
  }
  
  .magazine-team-name {
    font-size: 1rem;
  }
  
  .magazine-subtitle {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .magazine-covers-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .magazine-cover-image {
    max-width: 250px;
  }
  
  .magazine-cover-image img {
    height: 250px;
    object-fit: contain;
    object-position: center;
    background-color: var(--color-primary);
    padding: 3rem;
  }
}

@media (max-width: 500px) {
  .film-video-magazine-container {
    padding: 0 1rem;
  }
  
  .magazine-section-title {
    font-size: 1.8rem;
  }
  
  .magazine-team-role {
    font-size: 1.1rem;
  }
  
  .magazine-subtitle {
    font-size: 1.3rem;
  }
  
  .magazine-cover-image {
    max-width: 200px;
  }
  
  .magazine-cover-image img {
    height: 200px;
    object-fit: contain;
    object-position: center;
    background-color: var(--color-primary);
    padding: 2rem;
  }
}

/* Österreichisches Filmservice Page Styles */
.osterreichisches-filmservice-page {
  width: 100%;
}

.osterreichisches-filmservice-content {
  background-color: white;
  padding: 4rem 0;
}

.osterreichisches-filmservice-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
}

.osterreichisches-main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}

  .osterreichisches-description {
    margin-bottom: 1rem;
    text-align: left;
  }
  
  /* Filmservice History Timeline Styles */
  .history-page {
    width: 100%;
  }
  
  .history-subtitle {
    background-color: var(--color-secondary);
    padding-bottom: 2rem;
    text-align: center;
  }
  
  .history-subtitle h3 {
    color: var(--color-text-secondary);
    font-size: 1.2rem;
    font-weight: 400;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 2px;
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  .timeline-sections {
    width: 100%;
  }
  
  .timeline-section {
    width: 100%;
    padding: 0 0;
  }
  
  .timeline-section.white-bg {
    background-color: white;
  }
  
  .timeline-section.secondary-bg {
    background-color: var(--color-secondary);
  }
  
  .timeline-section-container {
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
    display: flex;
    align-items: stretch;
    min-height: 400px;
  }
  
  .timeline-left {
    width: 100px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 3rem;
  }
  
  .timeline-line {
    position: absolute;
    left: 50%;
    top: -2rem;
    bottom: -2rem;
    width: 10px;
    background-color: var(--color-primary);
    transform: translateX(-50%);
    z-index: 1;
  }
  
  .timeline-section:first-child .timeline-line {
    top: 2rem;
  }
  
  .timeline-section:last-child .timeline-line {
    bottom: 2rem;
  }
  
  .timeline-year-circle {
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-secondary);
    font-weight: 400;
    font-size: 3.5rem;
    position: relative;
    z-index: 2;
    margin-top: 4rem;
    transform: rotate(-90deg);
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-family: var(--font-family-scrolling);
  }

  /* Timeline year background colors based on section */
  .timeline-section.white-bg .timeline-year-circle {
    background-color: var(--color-white);
  }

  .timeline-section.secondary-bg .timeline-year-circle {
    background-color: var(--color-secondary);
  }
  
  
  .timeline-multiple-years {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }
  
  .timeline-section-content {
    display: flex;
    align-items: center;
    gap: 4rem;
    flex: 1 1;
    padding: 2rem 0;
  }
  
  .timeline-section-content.image-right {
    flex-direction: row;
  }
  
  .timeline-section-content.image-left {
    flex-direction: row-reverse;
  }
  
  .timeline-text-content {
    flex: 1 1;
    max-width: 600px;
  }
  
  .timeline-section-text {
    line-height: 1.6;
  }
  
  .timeline-section-text p {
    margin: 0;
    font-size: 1.1rem;
  }
  
  .white-bg .timeline-section-text p {
    color: #333;
  }
  
  .secondary-bg .timeline-section-text p {
    color: white;
  }
  
  .timeline-section-image {
    flex: 0 0 400px;
    max-width: 400px;
  }
  
  .timeline-section-image img {
    width: 100%;
    height: auto;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
  
  /* Final Section Styles */
  .final-section {
    background-color: var(--color-secondary);
    padding: 4rem 0;
  }
  
  .final-section-container {
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  .final-section-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .final-text-content {
    max-width: 800px;
    color: white;
  }
  
  .final-main-text {
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 2rem;
  }
  
  .final-call-to-action {
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
  }
  
  .final-team-message {
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
  }
  
  .final-closing {
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 3rem;
  }
  
  .final-signature {
    margin-top: 3rem;
    text-align: right;
  }
  
  .signature-name {
    font-size: 1.3rem;
    font-weight: bold;
    color: white;
    margin-bottom: 0;
  }
  
  .signature-title {
    font-size: 1rem;
    color: #cccccc;
    font-style: italic;
  }
  
  .final-section-image {
    flex: 0 0 400px;
    max-width: 400px;
  }
  
  .final-section-image img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
  
  /* Responsive Timeline Sections */
    @media (max-width: 1024px) {
      .timeline-left {
        width: 80px;
        margin-right: 2rem;
      }
     
      .timeline-year-circle {
        width: auto;
        height: auto;
        font-size: 2.8rem;
        padding: 0.4rem 0.8rem;
      }
      
      .timeline-multiple-years {
        gap: 0.8rem;
      }
     
     .timeline-section-content {
       gap: 2rem;
     }
     
     .timeline-section-image {
       flex: 0 0 300px;
       max-width: 300px;
     }
   }
  
  @media (max-width: 768px) {
    .history-subtitle h3 {
      font-size: 1rem;
      letter-spacing: 1px;
    }
    
         .timeline-section {
       padding: 2rem 0;
     }
     
     .timeline-section-container {
       flex-direction: column;
       align-items: center;
       min-height: auto;
     }
     
     .timeline-left {
       width: 70px;
       margin-right: 0;
       margin-bottom: 1rem;
       height: auto;
     }
     
     .timeline-line {
       display: none;
     }
     
      .timeline-year-circle {
        width: auto;
        height: auto;
        font-size: 2.8rem;
        margin-top: 0;
        padding: 0.3rem 0.6rem;
        transform: rotate(0deg);
      }
      
      .timeline-multiple-years {
        gap: 0.5rem;
        height: auto;
        flex-direction: row;
      }

     .timeline-section-content {
       flex-direction: column !important;
       text-align: center;
       gap: 2rem;
       padding: 1rem 0;
     }
    
         .timeline-text-content {
       max-width: 100%;
     }
     
     .timeline-section-text p {
       font-size: 1rem;
     }
     
     .timeline-section-image {
       flex: none;
       max-width: 100%;
     }
     
     .final-text-content {
       max-width: 100%;
       padding: 0 1rem;
     }
  }
  
  @media (max-width: 480px) {
    .timeline-section-container {
      padding: 0 1rem;
    }
    
    .history-subtitle {
      padding: 2rem 0;
    }
    
    .history-subtitle h3 {
      font-size: 1rem;
      padding: 0 1rem;
    }
    
    .timeline-section {
      padding: 2rem 0;
    }
    
    .timeline-year-circle {
      width: auto;
      height: auto;
      font-size: 2.2rem;
      padding: 0.2rem 0.5rem;
    }
      
      .timeline-multiple-years {
        gap: 0.3rem;
      }
     
     .timeline-section-text p {
       font-size: 0.9rem;
     }
     
     .final-section {
       padding: 2rem 0;
     }
     
     .final-main-text,
     .final-call-to-action,
     .final-team-message,
     .final-closing {
       font-size: 1rem;
     }
     
     .signature-name {
       font-size: 1.1rem;
     }
  }

.osterreichisches-description p {
  font-family: var(--font-family-primary);
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--color-text-dark);
  margin: 0;
  line-height: 1.5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Contact Section */
.osterreichisches-contact {
  display: flex;
  flex-direction: column;
}

.osterreichisches-contact-title {
  font-family: var(--font-family-primary);
  font-size: 3rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 2rem 0;
  text-transform: uppercase;
  letter-spacing: -0.02em;
}

.osterreichisches-contact-name {
  font-family: var(--font-family-primary);
  font-size: 1.5rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 1.5rem 0;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

.osterreichisches-contact-email {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.osterreichisches-contact-email i {
  color: var(--color-text-dark);
  flex-shrink: 0;
  font-size: 1rem;
}

.osterreichisches-contact-email a {
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-dark);
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.3s ease;
}

.osterreichisches-contact-email a:hover {
  color: var(--color-primary);
}

/* Map Section */
.osterreichisches-map {
  display: flex;
  justify-content: flex-end;
}

.osterreichisches-map-link {
  display: block;
  text-decoration: none;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.osterreichisches-map-link:hover {
  transform: scale(1.02);
}

.osterreichisches-map-link img {
  width: 100%;
  max-width: 500px;
  height: auto;
  display: block;
}

/* Responsive Design */
@media (max-width: 768px) {
  .osterreichisches-filmservice-content {
    padding: 2rem 0;
  }
  
  .osterreichisches-description {
    margin-bottom: 2rem;
  }
  
  .osterreichisches-description p {
    font-size: 0.7rem;
  }
  
  .osterreichisches-main-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  
  .osterreichisches-contact-title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
  
  .osterreichisches-contact-name {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  
  .osterreichisches-contact-email a {
    font-size: 0.9rem;
  }
  
  .osterreichisches-map {
    justify-content: center;
  }
  
  .osterreichisches-map-link img {
    max-width: 400px;
  }
}

@media (max-width: 500px) {
  .osterreichisches-filmservice-container {
    padding: 0 1rem;
  }
  
  .osterreichisches-description {
    margin-bottom: 2rem;
  }
  
  .osterreichisches-description p {
    font-size: 0.6rem;
    text-align: left;
  }
  
  .osterreichisches-main-grid {
    gap: 2rem;
  }
  
  .osterreichisches-contact-title {
    font-size: 1.8rem;
  }
  
  .osterreichisches-contact-name {
    font-size: 1.1rem;
  }
  
  .osterreichisches-contact-email {
    gap: 0.5rem;
  }
  
  .osterreichisches-contact-email i {
    font-size: 0.9rem;
  }
  
  .osterreichisches-contact-email a {
    font-size: 0.8rem;
  }
  
  .osterreichisches-map-link img {
    max-width: 300px;
  }
}

/* Nominate a Jury Page Specific Styles */
.nominate-jury-page {
  width: 100%;
  min-height: 100vh;
}

.nominate-jury-content {
  background-color: white;
  padding: 0rem 4rem;
  min-height: auto;
}

.nominate-jury-main {
  max-width: 1500px;
  margin: 0 auto;
  text-align: center;
}

.nominate-jury-text {
  color: var(--color-text-dark);
}

.nominate-jury-paragraph {
  font-size: 1rem !important;
  line-height: 1.6 !important;
  color: var(--color-text-dark) !important;
  font-weight: 500;
  text-align: justify;
}

/* Responsive Design for Nominate Jury */
@media (max-width: 768px) {
  .nominate-jury-content {
    padding: 0rem 3rem;
  }
}

@media (max-width: 500px) {
  .nominate-jury-content {
    padding: 0rem 2rem;
  }

  .nominate-jury-paragraph {
    font-size: 1rem;
    text-align: left;
  }
}

@media (max-width: 320px) {
  .nominate-jury-content {
    padding: 0rem 1rem;
  }
}

/* Partners Page Styles */
.partners-page {
  width: 100%;
  background-color: var(--color-secondary);
}

.partners-content {
  margin-top: 2rem;
  width: 100%;
}

.partners-section-spacer {
  width: 100%;
  height: 4rem;
  background-color: var(--color-secondary);
}

.partners-container {
  width: 100%;
}

.partners-section {
  padding: 1.5rem 2rem;
  width: 100%;
  background-color: var(--color-white);
  max-width: 1500px;
  margin: 0 auto;
  margin-bottom: 2rem;
}

.partners-section-title {
  font-family: var(--font-family-scrolling);
  font-size: 4rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 3rem 0;
  text-align: left;
  color: var(--color-black);
}

.partners-logos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  align-items: center;
  justify-items: center;
}

.partner-logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 150px;
  padding: 1rem;
}

.partner-logo-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

.partner-logo-item:hover img {
  filter: brightness(1);
  transform: scale(1.05);
}

/* Responsive Design for Partners */
@media (max-width: 768px) {
  .partners-section {
    padding: 3rem 0;
  }
  
  .partners-section-title {
    font-size: 3rem;
    margin-bottom: 2rem;
  }
  
  .partners-section {
    padding: 3rem 1rem;
    margin-bottom: 2rem;
  }
  
  .partners-logos-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
  }
  
  .partner-logo-item {
    height: 120px;
    padding: 0.5rem;
  }
}

@media (max-width: 500px) {
  .partners-section {
    padding: 2rem 1rem;
    margin-bottom: 2rem;
  }
  
  .partners-section-title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  .partners-logos-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1.5rem;
  }
  
  .partner-logo-item {
    height: 100px;
    padding: 0.5rem;
  }
}

/* Imprint Page Styles */
.imprint-page {
  width: 100%;
}

.imprint-content {
  background-color: white;
  padding: 4rem 0;
}

.imprint-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
}

.imprint-section-title {
  font-family: var(--font-family-primary);
  font-size: 3rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 3rem 0;
  text-transform: uppercase;
  letter-spacing: -0.02em;
}

.imprint-info-block {
  margin-bottom: 2.5rem;
}

.imprint-company-name {
  font-family: var(--font-family-primary);
  font-size: 1.8rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

.imprint-subsection-title {
  font-family: var(--font-family-primary);
  font-size: 1.5rem;
  font-weight: 900;
  color: var(--color-black);
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

.imprint-text {
  font-family: var(--font-family-primary);
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-text-dark);
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

.imprint-link {
  color: var(--color-text-dark);
  text-decoration: underline;
  transition: color 0.3s ease;
}

.imprint-link:hover {
  color: var(--color-primary);
  text-decoration: underline;
}

/* Responsive Design for Imprint Page */
@media (max-width: 768px) {
  .imprint-content {
    padding: 2rem 0;
  }

  .imprint-section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .imprint-section {
    margin-bottom: 3rem;
  }

  .imprint-info-block {
    margin-bottom: 2rem;
  }

  .imprint-company-name {
    font-size: 1.5rem;
  }

  .imprint-subsection-title {
    font-size: 1.2rem;
  }

  .imprint-text {
    font-size: 1rem;
  }
}

@media (max-width: 500px) {
  .imprint-container {
    padding: 0 1rem;
  }

  .imprint-section-title {
    font-size: 1.8rem;
  }

  .imprint-company-name {
    font-size: 1.3rem;
  }

  .imprint-subsection-title {
    font-size: 1.1rem;
  }

  .imprint-text {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Page.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;KAEG;KACA,eAAe;GACjB;;GAEA;KACE,eAAe;GACjB;;GAEA;KACE,0BAA0B;KAC1B,WAAW;GACb;;GAEA;KACE,aAAa;KACb,iBAAiB;KACjB,oBAAoB;GACtB;AACH;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA,6CAA6C;AAC7C;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;EAEE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;IACE,WAAW;EACb;;EAEA;IACE,wCAAwC;IACxC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,WAAW;IACX,sCAAsC;IACtC,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA,qDAAqD;EACrD;IACE,oCAAoC;EACtC;;EAEA;IACE,wCAAwC;EAC1C;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;EAC5C;;EAEA,yBAAyB;EACzB;IACE,wCAAwC;IACxC,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA,iCAAiC;IAC/B;MACE;QACE,WAAW;QACX,kBAAkB;MACpB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,sBAAsB;MACxB;;MAEA;QACE,WAAW;MACb;;KAED;OACE,SAAS;KACX;;KAEA;OACE,eAAe;OACf,gBAAgB;KAClB;GACF;;EAED;IACE;MACE,eAAe;MACf,mBAAmB;IACrB;;SAEK;OACF,eAAe;KACjB;;KAEA;OACE,sBAAsB;OACtB,mBAAmB;OACnB,gBAAgB;KAClB;;KAEA;OACE,WAAW;OACX,eAAe;OACf,mBAAmB;OACnB,YAAY;KACd;;KAEA;OACE,aAAa;KACf;;MAEC;QACE,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;MACzB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,mBAAmB;MACrB;;KAED;OACE,iCAAiC;OACjC,kBAAkB;OAClB,SAAS;OACT,eAAe;KACjB;;SAEI;OACF,eAAe;KACjB;;KAEA;OACE,eAAe;KACjB;;KAEA;OACE,UAAU;OACV,eAAe;KACjB;;KAEA;OACE,eAAe;OACf,eAAe;KACjB;EACH;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,sBAAsB;IACxB;;MAEE;QACE,WAAW;MACb;;KAED;OACE,iBAAiB;KACnB;;KAEA;OACE,eAAe;KACjB;;KAEA;;;;OAIE,eAAe;KACjB;;KAEA;OACE,iBAAiB;KACnB;EACH;;AAEF;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Shared Page Styles */\n.page-container {\n  min-height: 60vh;\n  background-color: var(--color-secondary);\n  padding: 4rem 2rem;\n}\n\n.page-content {\n  max-width: 1500px;\n  margin: 0 auto;\n  color: var(--color-text-primary);\n}\n\n.page-content h1 {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--color-primary);\n  text-align: center;\n}\n\n.page-content h2 {\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 2rem 0 1rem 0;\n  color: var(--color-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.content-section {\n  padding: 2rem;\n  border-radius: 15px;\n  margin-bottom: 2rem;\n}\n\n.content-section p {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  margin-bottom: 1.5rem;\n  color: var(--color-text-primary);\n}\n\n.content-section ul {\n  margin: 1rem 0;\n  padding-left: 2rem;\n}\n\n.content-section li {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 0.5rem;\n  color: var(--color-text-primary);\n}\n\n/* About Page Specific Styles */\n.about-page {\n  background-color: var(--color-secondary);\n}\n\n.about-content {\n  padding: 0rem 2rem;\n  min-height: auto;\n}\n\n.about-main {\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.about-description {\n  font-size: 1rem !important;\n  line-height: 1.6 !important;\n  color: var(--color-text-primary);\n  margin-bottom: 2rem;\n  text-align: justify;\n}\n\n.about-cta {\n  line-height: 1.8;\n  color: var(--color-text-secondary)!important;\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.about-festivals-section {\n  background-color: var(--color-secondary);\n  padding-top: 0;\n  padding-bottom: 2rem;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Alexander V. Kammel Biography Page Specific Styles */\n.alexander-kammel-page {\n  background-color: var(--color-secondary);\n}\n\n.alexander-kammel-content {\n  padding: 0rem 2rem;\n  min-height: auto;\n}\n\n.alexander-kammel-main {\n  max-width: 1500px;\n  margin: 0 auto;\n}\n\n.alexander-kammel-text-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  margin-bottom: 4rem;\n}\n\n.alexander-kammel-left-column,\n.alexander-kammel-right-column {\n  color: var(--color-text-primary);\n}\n\n.alexander-kammel-left-column p,\n.alexander-kammel-right-column p {\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n  text-align: justify;\n}\n\n.alexander-kammel-images-section {\n  background-color: var(--color-white);\n  width: 100%;\n  padding: 4rem 0;\n}\n\n.alexander-kammel-images-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.alexander-kammel-images {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.alexander-kammel-image {\n  width: 100%;\n}\n\n.alexander-kammel-image img {\n  width: 100%;\n  height: 600px;\n  object-fit: cover;\n  object-position: top;\n}\n\n/* Tablet Responsive Design */\n@media (max-width: 768px) and (min-width: 500px) {\n  .alexander-kammel-images-section {\n    padding: 3rem 0;\n  }\n  \n  .alexander-kammel-images-container {\n    padding: 0 1rem;\n  }\n  \n  .alexander-kammel-image img {\n    height: 500px;\n    object-fit: cover;\n    object-position: top;\n  }\n}\n\n/* Mobile Responsive Design */\n@media (max-width: 500px) {\n  .page-container {\n    padding: 2rem 1rem;\n  }\n  \n  .page-content h1 {\n    font-size: 2rem;\n  }\n  \n  .page-content h2 {\n    font-size: 1.5rem;\n  }\n  \n  .content-section {\n    padding: 1.5rem;\n  }\n\n  .about-content {\n    padding: 2rem 1rem;\n  }\n  \n  .about-description {\n    font-size: 1rem;\n    text-align: left;\n  }\n  \n  .about-cta {\n    font-size: 1rem;\n    text-align: left;\n  }\n\n  .alexander-kammel-content {\n    padding: 2rem 1rem;\n  }\n  \n  .alexander-kammel-text-columns {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  .alexander-kammel-left-column p,\n  .alexander-kammel-right-column p {\n    font-size: 0.9rem;\n    text-align: left;\n  }\n  \n     .alexander-kammel-images-section {\n     padding: 2rem 0;\n   }\n   \n   .alexander-kammel-images-container {\n     padding: 0 1rem;\n   }\n   \n   .alexander-kammel-images {\n     grid-template-columns: 1fr;\n     gap: 1.5rem;\n   }\n   \n   .alexander-kammel-image img {\n     height: 400px;\n     object-fit: cover;\n     object-position: top;\n   }\n}\n\n/* Film + Video Magazine Page Styles */\n.film-video-magazine-page {\n  width: 100%;\n  min-height: 100vh;\n}\n\n.film-video-magazine-content {\n  background-color: white;\n  padding: 4rem 0;\n  min-height: 100vh;\n}\n\n.film-video-magazine-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.magazine-section-title {\n  font-family: var(--font-family-primary);\n  font-size: 3rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 3rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.02em;\n}\n\n/* Team Section */\n.magazine-team-section {\n  margin-bottom: 6rem;\n}\n\n.magazine-team-item {\n  margin-bottom: 3rem;\n}\n\n.magazine-team-role {\n  font-family: var(--font-family-primary);\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 0.5rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n}\n\n.magazine-team-name {\n  font-family: var(--font-family-primary);\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  margin: 0 0 0.25rem 0;\n  line-height: 1.4;\n}\n\n/* Magazine Section */\n.magazine-covers-section {\n  margin-bottom: 4rem;\n}\n\n.magazine-subtitle {\n  font-family: var(--font-family-primary);\n  font-size: 2rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 3rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n}\n\n.magazine-covers-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0rem;\n  margin-top: 2rem;\n  justify-items: center;\n}\n\n.magazine-cover-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.magazine-cover-image {\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: 0.5rem;\n  display: block;\n  text-decoration: none;\n}\n\n.magazine-cover-image img {\n  width: 100%;\n  height: 300px;\n  object-fit: contain;\n  object-position: center;\n  transition: transform 0.3s ease;\n  background-color: var(--color-primary);\n  padding: 4rem;\n}\n\n.magazine-cover-image img:hover {\n  transform: scale(1.05);\n}\n\n.magazine-cover-hashtags {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0rem;\n}\n\n.magazine-hashtag {\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  text-transform: lowercase;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .film-video-magazine-content {\n    padding: 2rem 0;\n  }\n  \n  .magazine-section-title {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  .magazine-team-section {\n    margin-bottom: 4rem;\n  }\n  \n  .magazine-team-item {\n    margin-bottom: 2rem;\n  }\n  \n  .magazine-team-role {\n    font-size: 1.2rem;\n  }\n  \n  .magazine-team-name {\n    font-size: 1rem;\n  }\n  \n  .magazine-subtitle {\n    font-size: 1.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .magazine-covers-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .magazine-cover-image {\n    max-width: 250px;\n  }\n  \n  .magazine-cover-image img {\n    height: 250px;\n    object-fit: contain;\n    object-position: center;\n    background-color: var(--color-primary);\n    padding: 3rem;\n  }\n}\n\n@media (max-width: 500px) {\n  .film-video-magazine-container {\n    padding: 0 1rem;\n  }\n  \n  .magazine-section-title {\n    font-size: 1.8rem;\n  }\n  \n  .magazine-team-role {\n    font-size: 1.1rem;\n  }\n  \n  .magazine-subtitle {\n    font-size: 1.3rem;\n  }\n  \n  .magazine-cover-image {\n    max-width: 200px;\n  }\n  \n  .magazine-cover-image img {\n    height: 200px;\n    object-fit: contain;\n    object-position: center;\n    background-color: var(--color-primary);\n    padding: 2rem;\n  }\n}\n\n/* Österreichisches Filmservice Page Styles */\n.osterreichisches-filmservice-page {\n  width: 100%;\n}\n\n.osterreichisches-filmservice-content {\n  background-color: white;\n  padding: 4rem 0;\n}\n\n.osterreichisches-filmservice-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.osterreichisches-main-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: start;\n}\n\n  .osterreichisches-description {\n    margin-bottom: 1rem;\n    text-align: left;\n  }\n  \n  /* Filmservice History Timeline Styles */\n  .history-page {\n    width: 100%;\n  }\n  \n  .history-subtitle {\n    background-color: var(--color-secondary);\n    padding-bottom: 2rem;\n    text-align: center;\n  }\n  \n  .history-subtitle h3 {\n    color: var(--color-text-secondary);\n    font-size: 1.2rem;\n    font-weight: 400;\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    max-width: 1500px;\n    margin: 0 auto;\n    padding: 0 2rem;\n  }\n  \n  .timeline-sections {\n    width: 100%;\n  }\n  \n  .timeline-section {\n    width: 100%;\n    padding: 0 0;\n  }\n  \n  .timeline-section.white-bg {\n    background-color: white;\n  }\n  \n  .timeline-section.secondary-bg {\n    background-color: var(--color-secondary);\n  }\n  \n  .timeline-section-container {\n    max-width: 1500px;\n    margin: 0 auto;\n    padding: 0 2rem;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    min-height: 400px;\n  }\n  \n  .timeline-left {\n    width: 100px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-right: 3rem;\n  }\n  \n  .timeline-line {\n    position: absolute;\n    left: 50%;\n    top: -2rem;\n    bottom: -2rem;\n    width: 10px;\n    background-color: var(--color-primary);\n    transform: translateX(-50%);\n    z-index: 1;\n  }\n  \n  .timeline-section:first-child .timeline-line {\n    top: 2rem;\n  }\n  \n  .timeline-section:last-child .timeline-line {\n    bottom: 2rem;\n  }\n  \n  .timeline-year-circle {\n    width: auto;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-text-secondary);\n    font-weight: 400;\n    font-size: 3.5rem;\n    position: relative;\n    z-index: 2;\n    margin-top: 4rem;\n    transform: rotate(-90deg);\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    font-family: var(--font-family-scrolling);\n  }\n\n  /* Timeline year background colors based on section */\n  .timeline-section.white-bg .timeline-year-circle {\n    background-color: var(--color-white);\n  }\n\n  .timeline-section.secondary-bg .timeline-year-circle {\n    background-color: var(--color-secondary);\n  }\n  \n  \n  .timeline-multiple-years {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n  }\n  \n  .timeline-section-content {\n    display: flex;\n    align-items: center;\n    gap: 4rem;\n    flex: 1;\n    padding: 2rem 0;\n  }\n  \n  .timeline-section-content.image-right {\n    flex-direction: row;\n  }\n  \n  .timeline-section-content.image-left {\n    flex-direction: row-reverse;\n  }\n  \n  .timeline-text-content {\n    flex: 1;\n    max-width: 600px;\n  }\n  \n  .timeline-section-text {\n    line-height: 1.6;\n  }\n  \n  .timeline-section-text p {\n    margin: 0;\n    font-size: 1.1rem;\n  }\n  \n  .white-bg .timeline-section-text p {\n    color: #333;\n  }\n  \n  .secondary-bg .timeline-section-text p {\n    color: white;\n  }\n  \n  .timeline-section-image {\n    flex: 0 0 400px;\n    max-width: 400px;\n  }\n  \n  .timeline-section-image img {\n    width: 100%;\n    height: auto;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* Final Section Styles */\n  .final-section {\n    background-color: var(--color-secondary);\n    padding: 4rem 0;\n  }\n  \n  .final-section-container {\n    max-width: 1500px;\n    margin: 0 auto;\n    padding: 0 2rem;\n  }\n  \n  .final-section-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .final-text-content {\n    max-width: 800px;\n    color: white;\n  }\n  \n  .final-main-text {\n    font-size: 1.2rem;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n  \n  .final-call-to-action {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n  \n  .final-team-message {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n  \n  .final-closing {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    margin-bottom: 3rem;\n  }\n  \n  .final-signature {\n    margin-top: 3rem;\n    text-align: right;\n  }\n  \n  .signature-name {\n    font-size: 1.3rem;\n    font-weight: bold;\n    color: white;\n    margin-bottom: 0;\n  }\n  \n  .signature-title {\n    font-size: 1rem;\n    color: #cccccc;\n    font-style: italic;\n  }\n  \n  .final-section-image {\n    flex: 0 0 400px;\n    max-width: 400px;\n  }\n  \n  .final-section-image img {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* Responsive Timeline Sections */\n    @media (max-width: 1024px) {\n      .timeline-left {\n        width: 80px;\n        margin-right: 2rem;\n      }\n     \n      .timeline-year-circle {\n        width: auto;\n        height: auto;\n        font-size: 2.8rem;\n        padding: 0.4rem 0.8rem;\n      }\n      \n      .timeline-multiple-years {\n        gap: 0.8rem;\n      }\n     \n     .timeline-section-content {\n       gap: 2rem;\n     }\n     \n     .timeline-section-image {\n       flex: 0 0 300px;\n       max-width: 300px;\n     }\n   }\n  \n  @media (max-width: 768px) {\n    .history-subtitle h3 {\n      font-size: 1rem;\n      letter-spacing: 1px;\n    }\n    \n         .timeline-section {\n       padding: 2rem 0;\n     }\n     \n     .timeline-section-container {\n       flex-direction: column;\n       align-items: center;\n       min-height: auto;\n     }\n     \n     .timeline-left {\n       width: 70px;\n       margin-right: 0;\n       margin-bottom: 1rem;\n       height: auto;\n     }\n     \n     .timeline-line {\n       display: none;\n     }\n     \n      .timeline-year-circle {\n        width: auto;\n        height: auto;\n        font-size: 2.8rem;\n        margin-top: 0;\n        padding: 0.3rem 0.6rem;\n        transform: rotate(0deg);\n      }\n      \n      .timeline-multiple-years {\n        gap: 0.5rem;\n        height: auto;\n        flex-direction: row;\n      }\n\n     .timeline-section-content {\n       flex-direction: column !important;\n       text-align: center;\n       gap: 2rem;\n       padding: 1rem 0;\n     }\n    \n         .timeline-text-content {\n       max-width: 100%;\n     }\n     \n     .timeline-section-text p {\n       font-size: 1rem;\n     }\n     \n     .timeline-section-image {\n       flex: none;\n       max-width: 100%;\n     }\n     \n     .final-text-content {\n       max-width: 100%;\n       padding: 0 1rem;\n     }\n  }\n  \n  @media (max-width: 480px) {\n    .timeline-section-container {\n      padding: 0 1rem;\n    }\n    \n    .history-subtitle {\n      padding: 2rem 0;\n    }\n    \n    .history-subtitle h3 {\n      font-size: 1rem;\n      padding: 0 1rem;\n    }\n    \n    .timeline-section {\n      padding: 2rem 0;\n    }\n    \n    .timeline-year-circle {\n      width: auto;\n      height: auto;\n      font-size: 2.2rem;\n      padding: 0.2rem 0.5rem;\n    }\n      \n      .timeline-multiple-years {\n        gap: 0.3rem;\n      }\n     \n     .timeline-section-text p {\n       font-size: 0.9rem;\n     }\n     \n     .final-section {\n       padding: 2rem 0;\n     }\n     \n     .final-main-text,\n     .final-call-to-action,\n     .final-team-message,\n     .final-closing {\n       font-size: 1rem;\n     }\n     \n     .signature-name {\n       font-size: 1.1rem;\n     }\n  }\n\n.osterreichisches-description p {\n  font-family: var(--font-family-primary);\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  margin: 0;\n  line-height: 1.5;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Contact Section */\n.osterreichisches-contact {\n  display: flex;\n  flex-direction: column;\n}\n\n.osterreichisches-contact-title {\n  font-family: var(--font-family-primary);\n  font-size: 3rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 2rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.02em;\n}\n\n.osterreichisches-contact-name {\n  font-family: var(--font-family-primary);\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 1.5rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n}\n\n.osterreichisches-contact-email {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.osterreichisches-contact-email i {\n  color: var(--color-text-dark);\n  flex-shrink: 0;\n  font-size: 1rem;\n}\n\n.osterreichisches-contact-email a {\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  line-height: 1.4;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.osterreichisches-contact-email a:hover {\n  color: var(--color-primary);\n}\n\n/* Map Section */\n.osterreichisches-map {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.osterreichisches-map-link {\n  display: block;\n  text-decoration: none;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n}\n\n.osterreichisches-map-link:hover {\n  transform: scale(1.02);\n}\n\n.osterreichisches-map-link img {\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  display: block;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .osterreichisches-filmservice-content {\n    padding: 2rem 0;\n  }\n  \n  .osterreichisches-description {\n    margin-bottom: 2rem;\n  }\n  \n  .osterreichisches-description p {\n    font-size: 0.7rem;\n  }\n  \n  .osterreichisches-main-grid {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n  \n  .osterreichisches-contact-title {\n    font-size: 2rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .osterreichisches-contact-name {\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n  }\n  \n  .osterreichisches-contact-email a {\n    font-size: 0.9rem;\n  }\n  \n  .osterreichisches-map {\n    justify-content: center;\n  }\n  \n  .osterreichisches-map-link img {\n    max-width: 400px;\n  }\n}\n\n@media (max-width: 500px) {\n  .osterreichisches-filmservice-container {\n    padding: 0 1rem;\n  }\n  \n  .osterreichisches-description {\n    margin-bottom: 2rem;\n  }\n  \n  .osterreichisches-description p {\n    font-size: 0.6rem;\n    text-align: left;\n  }\n  \n  .osterreichisches-main-grid {\n    gap: 2rem;\n  }\n  \n  .osterreichisches-contact-title {\n    font-size: 1.8rem;\n  }\n  \n  .osterreichisches-contact-name {\n    font-size: 1.1rem;\n  }\n  \n  .osterreichisches-contact-email {\n    gap: 0.5rem;\n  }\n  \n  .osterreichisches-contact-email i {\n    font-size: 0.9rem;\n  }\n  \n  .osterreichisches-contact-email a {\n    font-size: 0.8rem;\n  }\n  \n  .osterreichisches-map-link img {\n    max-width: 300px;\n  }\n}\n\n/* Nominate a Jury Page Specific Styles */\n.nominate-jury-page {\n  width: 100%;\n  min-height: 100vh;\n}\n\n.nominate-jury-content {\n  background-color: white;\n  padding: 0rem 4rem;\n  min-height: auto;\n}\n\n.nominate-jury-main {\n  max-width: 1500px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.nominate-jury-text {\n  color: var(--color-text-dark);\n}\n\n.nominate-jury-paragraph {\n  font-size: 1rem !important;\n  line-height: 1.6 !important;\n  color: var(--color-text-dark) !important;\n  font-weight: 500;\n  text-align: justify;\n}\n\n/* Responsive Design for Nominate Jury */\n@media (max-width: 768px) {\n  .nominate-jury-content {\n    padding: 0rem 3rem;\n  }\n}\n\n@media (max-width: 500px) {\n  .nominate-jury-content {\n    padding: 0rem 2rem;\n  }\n\n  .nominate-jury-paragraph {\n    font-size: 1rem;\n    text-align: left;\n  }\n}\n\n@media (max-width: 320px) {\n  .nominate-jury-content {\n    padding: 0rem 1rem;\n  }\n}\n\n/* Partners Page Styles */\n.partners-page {\n  width: 100%;\n  background-color: var(--color-secondary);\n}\n\n.partners-content {\n  margin-top: 2rem;\n  width: 100%;\n}\n\n.partners-section-spacer {\n  width: 100%;\n  height: 4rem;\n  background-color: var(--color-secondary);\n}\n\n.partners-container {\n  width: 100%;\n}\n\n.partners-section {\n  padding: 1.5rem 2rem;\n  width: 100%;\n  background-color: var(--color-white);\n  max-width: 1500px;\n  margin: 0 auto;\n  margin-bottom: 2rem;\n}\n\n.partners-section-title {\n  font-family: var(--font-family-scrolling);\n  font-size: 4rem;\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin: 0 0 3rem 0;\n  text-align: left;\n  color: var(--color-black);\n}\n\n.partners-logos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 3rem;\n  align-items: center;\n  justify-items: center;\n}\n\n.partner-logo-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  padding: 1rem;\n}\n\n.partner-logo-item img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  transition: all 0.3s ease;\n}\n\n.partner-logo-item:hover img {\n  filter: brightness(1);\n  transform: scale(1.05);\n}\n\n/* Responsive Design for Partners */\n@media (max-width: 768px) {\n  .partners-section {\n    padding: 3rem 0;\n  }\n  \n  .partners-section-title {\n    font-size: 3rem;\n    margin-bottom: 2rem;\n  }\n  \n  .partners-section {\n    padding: 3rem 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .partners-logos-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 2rem;\n  }\n  \n  .partner-logo-item {\n    height: 120px;\n    padding: 0.5rem;\n  }\n}\n\n@media (max-width: 500px) {\n  .partners-section {\n    padding: 2rem 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .partners-section-title {\n    font-size: 2.5rem;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n  \n  .partners-logos-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 1.5rem;\n  }\n  \n  .partner-logo-item {\n    height: 100px;\n    padding: 0.5rem;\n  }\n}\n\n/* Imprint Page Styles */\n.imprint-page {\n  width: 100%;\n}\n\n.imprint-content {\n  background-color: white;\n  padding: 4rem 0;\n}\n\n.imprint-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.imprint-section-title {\n  font-family: var(--font-family-primary);\n  font-size: 3rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 3rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.02em;\n}\n\n.imprint-info-block {\n  margin-bottom: 2.5rem;\n}\n\n.imprint-company-name {\n  font-family: var(--font-family-primary);\n  font-size: 1.8rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n}\n\n.imprint-subsection-title {\n  font-family: var(--font-family-primary);\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: var(--color-black);\n  margin: 0 0 0.5rem 0;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n}\n\n.imprint-text {\n  font-family: var(--font-family-primary);\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  margin: 0 0 0.25rem 0;\n  line-height: 1.4;\n}\n\n.imprint-link {\n  color: var(--color-text-dark);\n  text-decoration: underline;\n  transition: color 0.3s ease;\n}\n\n.imprint-link:hover {\n  color: var(--color-primary);\n  text-decoration: underline;\n}\n\n/* Responsive Design for Imprint Page */\n@media (max-width: 768px) {\n  .imprint-content {\n    padding: 2rem 0;\n  }\n\n  .imprint-section-title {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .imprint-section {\n    margin-bottom: 3rem;\n  }\n\n  .imprint-info-block {\n    margin-bottom: 2rem;\n  }\n\n  .imprint-company-name {\n    font-size: 1.5rem;\n  }\n\n  .imprint-subsection-title {\n    font-size: 1.2rem;\n  }\n\n  .imprint-text {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 500px) {\n  .imprint-container {\n    padding: 0 1rem;\n  }\n\n  .imprint-section-title {\n    font-size: 1.8rem;\n  }\n\n  .imprint-company-name {\n    font-size: 1.3rem;\n  }\n\n  .imprint-subsection-title {\n    font-size: 1.1rem;\n  }\n\n  .imprint-text {\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
